import React from 'react';
import './CarouselHome.css';

import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import { Carousel } from 'react-responsive-carousel';

function CarouselHome() {

    const itensCarousel = [

        {
            'id': 1,
            'imagem': 'https://saude.prefeitura.rio/wp-content/uploads/sites/47/2024/02/Dengue_CriancasAdolescentes_BannerRotativo.png',
            'urlRedirect': 'https://riosemdengue.prefeitura.rio/vacinacao/',
            'alt': 'banner vacinacao'
        },

        {
            'id': 2,
            'imagem': 'https://saude.prefeitura.rio/wp-content/uploads/sites/47/2025/01/JaneiroRoxo_BannerRotativo_1170x280px.png',
            'urlRedirect': 'https://pcrj.maps.arcgis.com/apps/webappviewer/index.html?id=014d8ab512a34f259bb27c8a13d4d65f',
            'alt': 'banner janeiro roxo'
        },

        {
            'id': 3,
            'imagem': 'https://saude.prefeitura.rio/wp-content/uploads/sites/47/2024/10/BannerSite_ProtocolodeCalor_1170x280px.png',
            'urlRedirect': 'https://saude.prefeitura.rio/protocolo-de-calor/',
            'alt': 'banner protocolo de calor'
        },

        {
            'id': 4,
            'imagem': 'https://saude.prefeitura.rio/wp-content/uploads/sites/47/2024/11/Poliomielite_BannerRotativo.png',
            'urlRedirect': 'https://saude.prefeitura.rio/vacinacao/paralisia-infantil/',
            'alt': 'banner poliomielite'
        },

        {
            'id': 5,
            'imagem': 'https://saude.prefeitura.rio/wp-content/uploads/sites/47/2024/04/VacinacaoHPV_BannerRotativo.png',
            'urlRedirect': 'https://pcrj.maps.arcgis.com/apps/webappviewer/index.html?id=014d8ab512a34f259bb27c8a13d4d65f',
            'alt': 'banner vacinacao hpv'
        },

        {
            'id': 6,
            'imagem': 'https://saude.prefeitura.rio/wp-content/uploads/sites/47/2023/06/DivulgacaoBiliotecaCariocaSUS_banner.png',
            'urlRedirect': 'https://bibliotecasus.subpav.org/',
            'alt': 'banner biblioteca carioca'
        },

        {
            'id': 7,
            'imagem': 'https://saude.prefeitura.rio/wp-content/uploads/sites/47/2022/12/img_RAIVA-HUMANA.png',
            'urlRedirect': 'https://saude.prefeitura.rio/vacinacao/raiva-humana/',
            'alt': 'banner raiva humana'
        },

        {
            'id': 8,
            'imagem': 'https://saude.prefeitura.rio/wp-content/uploads/sites/47/2024/02/Dengue_BannerRotativo.png',
            'urlRedirect': 'https://riosemdengue.prefeitura.rio/',
            'alt': 'banner dengue'
        },
        {
            'id': 9,
            'imagem': 'https://saude.prefeitura.rio/wp-content/uploads/sites/47/2023/03/SCCS_BannerRotativo_v3.png',
            'urlRedirect': 'https://saude.prefeitura.rio/unidades-de-saude/sccs/',
            'alt': 'banner sccs'
        },
        {
            'id': 10,
            'imagem': 'https://saude.prefeitura.rio/wp-content/uploads/sites/47/2022/01/banner-pesquisa-de-mercado.png',
            'urlRedirect': 'https://saude.prefeitura.rio/licitacoes/',
            'alt': 'banner pesquisa de mercado'
        },
        {
            'id': 11,
            'imagem': 'https://saude.prefeitura.rio/wp-content/uploads/sites/47/2022/02/chamada-publica.png',
            'urlRedirect': 'https://saude.prefeitura.rio/contratualizacao/chamadas-publicas/',
            'alt': 'banner contratacao e credenciamento servicos publicos'
        },
        {
            'id': 12,
            'imagem': 'https://saude.prefeitura.rio/wp-content/uploads/sites/47/2022/02/CONTRATOS-EMERGENCIAIS.png',
            'urlRedirect': 'https://saude.prefeitura.rio/wp-content/uploads/sites/47/2022/02/TRANSPARENCIA-CONTRATOS-EMERGENCIAIS-SMSRJ.pdf',
            'alt': 'banner contratos emergenciais'
        },
    ]

    return (

        // <div className='carouselContainer'>
            <Carousel autoPlay={true} infiniteLoop={true} showThumbs={false}>

                {itensCarousel.map((itemCarousel) =>
                    <div key={itemCarousel.id} className="containerImagem" onClick={() => window.open(itemCarousel.urlRedirect)}>
                        <img alt={itemCarousel.alt} src={itemCarousel.imagem}/>
                    </div>
                )}

            </Carousel>
        // </div>

    );
}

export default CarouselHome

